"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LoginRequired_1 = __importDefault(require("../../components/redeem/LoginRequired"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const RedeemActions_1 = __importDefault(require("../../actions/RedeemActions"));
const RedeemStore_1 = __importDefault(require("../../stores/RedeemStore"));
const react_router_1 = require("react-router");
const SuccessStage_1 = __importDefault(require("../../components/redeem/SuccessStage"));
const epic_alt_utils_1 = require("epic-alt-utils");
const query_string_1 = __importDefault(require("query-string"));
const route_1 = require("../../utils/route");
/**
 * RedeemSuccessView.
 *
 * Rendered when the Route matches /redeem/confirmation
 */
let RedeemSuccessView = class RedeemSuccessView extends react_1.default.Component {
    static getStores() {
        return [RedeemStore_1.default];
    }
    static getPropsFromStores() {
        return {
            redeemStore: RedeemStore_1.default.getState()
        };
    }
    static getInitialActions() {
        return [
            props => {
                if (props.redeemStore.redeemComplete) {
                    RedeemActions_1.default.clearEntitlementsFromSession.defer();
                }
            }
        ];
    }
    render() {
        let redeemSuccessViewContent = null;
        const { isLoggedIn } = this.props;
        if (isLoggedIn && !this.props.redeemStore.redeemComplete) {
            redeemSuccessViewContent = react_1.default.createElement(react_router_1.Redirect, { to: route_1.generateRouteTo('/redeem', this.props.location) });
        }
        else if (!isLoggedIn) {
            const code = this.props.location.search ? query_string_1.default.parse(this.props.location.search).code || '' : '';
            const loginPath = `${this.props.location.pathname}?code=${code}`;
            redeemSuccessViewContent = react_1.default.createElement(LoginRequired_1.default, { returnPath: loginPath, signupDisabled: true });
        }
        else {
            redeemSuccessViewContent = react_1.default.createElement(SuccessStage_1.default, Object.assign({}, this.props));
        }
        return react_1.default.createElement("div", { className: "redeemView" }, redeemSuccessViewContent);
    }
};
RedeemSuccessView.propTypes = {
    location: prop_types_1.default.object,
    redeemStore: prop_types_1.default.object,
    macDownloadUrl: prop_types_1.default.string,
    pcDownloadUrl: prop_types_1.default.string,
    supportedOS: prop_types_1.default.array,
    isLoggedIn: prop_types_1.default.bool
};
RedeemSuccessView = __decorate([
    epic_alt_utils_1.connectToStores
], RedeemSuccessView);
exports.default = react_router_1.withRouter(RedeemSuccessView);
//# sourceMappingURL=RedeemSuccessView.js.map